import { Loader2 } from "lucide-react";
import { cn } from "@/lib/cn";

/**
 * Inline loading state — single spinner + label.
 *
 * Used in side panes, modals, and any non-DataTable surface that needs
 * to show "loading…" without animating a full skeleton row. The
 * DataTable owns its own skeleton; reach for that for tables.
 */
export function LoadingState({
  label = "Loading…",
  size = "md",
  className,
}: {
  label?: React.ReactNode;
  size?: "sm" | "md";
  className?: string;
}) {
  const padding = size === "sm" ? "p-4" : "p-8";
  const iconSize = size === "sm" ? 12 : 14;
  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        "flex items-center justify-center gap-2 text-[12px] text-fg-muted",
        padding,
        className,
      )}
    >
      <Loader2 size={iconSize} className="animate-spin" aria-hidden />
      <span>{label}</span>
    </div>
  );
}
